<template>
  <b-container fluid class="my-2">
    <b-row class="footer-font-size">
      <div class="col-12 col-lg-6">
        <b-row
          class="
            d-md-flex d-lg-inline-flex
            justify-content-center justify-content-lg-start
            text-md-center
            py-2
          "
        >
          <div class="icon-padding">
            <a id="email" href="#" target="_blank" @click="share('email')">
              <img src="@/assets/landingIcons/icon_email_red.png" />
            </a>
          </div>
          <div class="icon-padding">
            <a id="whatsapp" href="#" target="_blank" @click="share('whatsapp')">
              <img src="@/assets/landingIcons/icon_whatsapp_red.png" />
            </a>
          </div>
          <div class="icon-padding">
            <a id="linkedin" href="#" target="_blank" @click="share('linkedin')">
              <img src="@/assets/landingIcons/icon_linkedin_red.png" />
            </a>
          </div>
          <div class="icon-padding">
            <a id="fb" href="#" target="_blank" @click="share('fb')">
              <img src="@/assets/landingIcons/icon_fb_red.png" />
            </a>
          </div>
          <div class="icon-padding">
            <a id="twitter" href="#" target="_blank" @click="share('twitter')">
              <img src="@/assets/landingIcons/icon_twitter_red.png" />
            </a>
          </div>
          <div class="icon-padding">
            <a id="weibo" href="#" target="_blank" @click="share('weibo')">
              <img src="@/assets/landingIcons/icon_weibo_red.png" />
            </a>
          </div>
        </b-row>
      </div>
      <div class="col-12 col-lg-6 text-right right-section main-theme">
        <div class="row my-1">
          <div class="col d-flex justify-content-center justify-content-lg-end pr-lg-4">
            <div class="footer-navigation">
              <router-link :to="{ name: 'Sitemap' }"> {{ $t("footer.sitemap") }} </router-link>
            </div>
            <div class="footer-navigation ml-1 ml-sm-2">
              | &nbsp;
              <a href="https://www.discoverhongkong.com/eng/terms-of-use.html">
                {{ $t("footer.tou") }}
              </a>
            </div>
            <div class="footer-navigation ml-1 ml-sm-2">
              | &nbsp;
              <a href="https://www.discoverhongkong.com/eng/privacy-policy.html">
                {{ $t("footer.privacy") }}
              </a>
            </div>
            <div class="footer-navigation ml-1 ml-sm-2">
              | &nbsp;
              <a href="https://www.discoverhongkong.com/eng/contact-us.html">
                {{ $t("footer.contact") }}
              </a>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col d-flex justify-content-center text-center justify-content-lg-end pr-lg-4">
            {{ $t("footer.copyright") }}
          </div>
        </div>
      </div>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "Footer",
  props: {},
  methods: {
    share(platform) {
      let title = document.title;
      let url = window.location.href;

      if (platform == "weibo") {
        window.open(
          "https://service.weibo.com/share/share.php?url=" +
            encodeURIComponent(url) +
            "&title=" +
            encodeURIComponent(title)
        );
      }
      if (platform == "twitter") {
        window.open(
          "https://twitter.com/intent/tweet?url=" +
            encodeURIComponent(url) +
            "&text=" +
            encodeURIComponent(title)
        );
      }
      if (platform == "fb") {
        window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url));
      }
      if (platform == "linkedin") {
        window.open(
          "https://www.linkedin.com/sharing/share-offsite/?url=" + encodeURIComponent(url)
        );
      }
      if (platform == "whatsapp") {
        window.open("https://wa.me/?text=" + encodeURIComponent(title + " " + url));
      }
      if (platform == "email") {
        window.open(
          "mailto:?subject=" + encodeURIComponent(title) + "&body=" + encodeURIComponent(url)
        );
      }
    },
  },
  updated() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.bottom-0 {
  bottom: 0;
}
.footer-font-size {
  font-size: 0.8rem;
}
.icon-padding {
  padding-left: 10px;
  padding-right: 10px;
}
.right-section {
  font-family: Arial, Helvetica, sans-serif;
}
.footer-navigation {
  a {
    text-decoration: none;
    color: #e81b29;
  }
}
@media (max-width: 450px) {
  .icon-padding {
    padding-left: 0;
    padding-right: 0;
  }
}
@media (max-width: 767px) {
  .footer-font-size {
    font-size: 0.7rem;
  }
}
</style>
